import find from 'lodash/find';
import throttle from 'lodash/throttle';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import {connect} from 'react-redux';
import AnimationUtils from '@spothero/utils/animation';
import DOMUtils from '@spothero/utils/dom';
import {toggleListView} from '../search-actions';
import SpotList from './SpotList';
import SpotListFeatureDesktop from './SpotListFeatureDesktop';
import SpotListSearchControls from '../controls/SpotListSearchControls';

const EventList = loadable(() => import('event/EventList'));
const SpotListFilters = loadable(() => import('./SpotListFilters'));

class SpotListContainerDesktop extends Component {
    static propTypes = {
        spots: PropTypes.arrayOf(PropTypes.object).isRequired,
        selectedSpot: PropTypes.object,
        isListVisible: PropTypes.bool.isRequired,
        isEvent: PropTypes.bool.isRequired,
        isEventListEnabled: PropTypes.bool.isRequired,
        showEventList: PropTypes.bool.isRequired,
        onToggleEventList: PropTypes.func.isRequired,
        toggleSpotList: PropTypes.func.isRequired,
        onListScroll: PropTypes.func,
        isPolishTimepickersEnabled: PropTypes.bool,
    };
    static defaultProps = {
        isListVisible: true,
    };

    componentDidMount() {
        const {spots, onListScroll} = this.props;

        this._activeSpot = find(spots, 'activeMarker');
        this._listThrottle = onListScroll ? throttle(onListScroll, 500) : null;
    }

    componentDidUpdate(prevProps, prevState) {
        const {selectedSpot: prevSelectedSpot} = prevProps;
        const {spots, selectedSpot, isListVisible, toggleSpotList} = this.props;
        const newActiveSpot = find(spots, 'activeMarker');
        const bodyWidth = DOMUtils.width('body');

        if (
            newActiveSpot &&
            (!this._activeSpot ||
                this._activeSpot.spotId !== newActiveSpot.spotId)
        ) {
            // if a new active spot is set, scroll the list to its position
            const item = DOMUtils.el(`.result${newActiveSpot.spotId}`);

            if (item) {
                AnimationUtils.scrollTo(
                    this._list,
                    item.offsetTop,
                    250,
                    'y',
                    () => {
                        DOMUtils.removeClass(item, 'highlight'); // remove it first in case it existed

                        // a short delay ensures the css animation repeats
                        setTimeout(() => {
                            DOMUtils.addClass(item, 'highlight');
                        }, 150);
                    }
                );
            }
        }

        this._activeSpot = newActiveSpot;

        if (
            (!prevSelectedSpot &&
                selectedSpot &&
                bodyWidth < 1020 &&
                isListVisible) ||
            (prevSelectedSpot && !selectedSpot && bodyWidth < 1020)
        ) {
            toggleSpotList();
        }
    }

    componentWillUnmount() {
        if (this._listThrottle) {
            this._listThrottle.cancel();
        }
    }

    render() {
        const {
            spots,
            isEvent,
            isEventListEnabled,
            showEventList,
            onToggleEventList,
            isPolishTimepickersEnabled,
        } = this.props;

        return (
            <div
                className="SpotListContainer"
                itemScope={isEvent ? true : null}
                itemType={isEvent ? 'http://schema.org/Event' : null}
            >
                <div className="list">
                    {!isPolishTimepickersEnabled && (
                        <SpotListFeatureDesktop
                            spots={spots}
                            showEventList={showEventList}
                            onToggleEventList={onToggleEventList}
                        />
                    )}
                    <div
                        className="list-scroll"
                        ref={node => {
                            this._list = node;
                        }}
                        onScroll={
                            isPolishTimepickersEnabled
                                ? this._listThrottle
                                : null
                        }
                    >
                        {isPolishTimepickersEnabled && (
                            <SpotListSearchControls
                                numSpots={spots.length}
                                showEventList={showEventList}
                                onToggleEventList={onToggleEventList}
                            />
                        )}
                        <SpotList spots={spots} />
                    </div>
                </div>
                <SpotListFilters />
                {isEventListEnabled && (
                    <EventList
                        showEventList={showEventList}
                        onToggleEventList={onToggleEventList}
                        isPolishTimepickersEnabled={isPolishTimepickersEnabled}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {
        search: {
            data: {searchType, selectedSpot, isListVisible},
        },
    } = state;

    return {
        isEvent: searchType === 'event',
        selectedSpot,
        isListVisible,
    };
};

const mapDispatchToProps = {
    toggleSpotList: toggleListView,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SpotListContainerDesktop);
